(() => {
  const initialized = new WeakSet();

  const isCollectionPage = () => document.body?.classList.contains('template-collection');

  const initOne = (slider) => {
    if (!slider || initialized.has(slider) || slider.swiper) return;
    initialized.add(slider);

    const dir = document.documentElement.getAttribute('dir');
    let nextEl = '.product-button-group .swiper-button-next';
    let prevEl = '.product-button-group .swiper-button-prev';
    if (dir === 'rtl') [nextEl, prevEl] = [prevEl, nextEl];

    const productSlider = new Swiper(slider, {
      pagination: { el: '.product-pagination .swiper-pagination', type: 'progressbar' },
      speed: 600,
      nested: !slider.closest('.editorial-products-showcase'),
      navigation: { nextEl, prevEl },
      allowTouchMove: !slider.closest('.editorial-products-showcase'),
      mousewheel: { forceToAxis: true },
      on: {
        slideChange() {
          this.slides.forEach((slide) => { slide.style.animation = 'none'; });
        },
      },
    });

    const slides = Array.from(productSlider.slides || []);
    if (!slides.length || !('IntersectionObserver' in window)) return;
    const remaining = new Set(slides);
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
        remaining.delete(entry.target);
      });
      if (!remaining.size) observer.disconnect();
    }, { threshold: 0.6 });
    slides.forEach((slide) => observer.observe(slide));
  };

  const schedule = (scope = document) => {
    const sliders = scope.querySelectorAll?.('.product-card-js') || [];

    if (isCollectionPage() && 'IntersectionObserver' in window) {
      const nearViewport = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          initOne(entry.target);
        });
      }, { rootMargin: '700px 0px', threshold: 0.01 });

      sliders.forEach((slider) => {
        if (!initialized.has(slider) && !slider.swiper) nearViewport.observe(slider);
      });
      return;
    }

    sliders.forEach(initOne);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => schedule(document), { once: true });
  } else {
    schedule(document);
  }

  document.addEventListener('shopify:section:load', (event) => schedule(event.target || document));
})();
